<template>
  <div id="app">
    <bbs-pdf :url="url"></bbs-pdf>
  </div>
</template>

<script>
import BbsPdf from "../../components/bbsPdf";

export default {
  name: 'app',
  components: {
    BbsPdf,
  },
  data () {
    return {
//    url: 'http://file.hainayx.com/file-server/download?fileUrl=group1/M00/00/21/wKgCEl2eqSeAML4kABY1vBiImfA306.pdf'
     url: '../static/download/yyxl.pdf'
    
    }
  }
}
</script>
<style scoped>
	.container{min-width:750px;}
</style>



// WEBPACK FOOTER //
// src/pages/pdf/pdfApply.vue